import { NavigationItem } from "./navigation.types";

export const navigations: NavigationItem[] = [
    {
        id: 'home',
        title: 'Accueil',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/home',
        authorized: ['User', 'Admin']
    },
    {
        id: 'data-settings',
        title: 'Paramètres de données',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/data-settings/models',
        authorized: ['Admin']
    },
    {
        id: 'data-management',
        title: 'Gestion des données',
        type: 'aside',
        icon: 'feather:database',
        authorized: ['Admin'],
        children: [
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'ingestions',
                title: 'Importation des données',
                type: 'basic',
                icon: 'heroicons_outline:cloud-arrow-up',
                link: '/data-management/ingestions'
            },
            {
                id: 'ingestions-validation',
                title: 'Validation de l\'importation des données',
                type: 'basic',
                icon: 'heroicons_outline:check-badge',
                link: '/data-management/ingestions/validation',
                authorized: ['validate_ingestions']
            },
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'data-sets',
                title: 'Jeux de données',
                type: 'basic',
                icon: 'feather:database',
                link: '/data-management/datasets'
            },
            {
                id: 'data-playground',
                title: 'OLAP Playground',
                type: 'basic',
                icon: 'feather:airplay',
                link: '/data-management/playground'
            }
        ]
    },
    {
        id: 'dashboard',
        title: 'Tableaux de bord',
        type: 'basic',
        icon: 'heroicons_outline:presentation-chart-line',
        link: '/data-management/dashboards',
        authorized: ['Admin', 'User']
    },
    {
        id: 'documents',
        title: 'Documents',
        type: 'basic',
        icon: 'heroicons_outline:document-duplicate',
        link: '/data-management/documents',
        authorized: ['Admin', 'User']
    },
    {
        id: 'graphics',
        title: 'Graphiques',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/data-management/graphic-templates',
        authorized: ['Admin', 'User']
    },
    {
        id: 'parameters',
        title: 'Paramètres',
        type: 'aside',
        icon: 'heroicons_outline:wrench-screwdriver',
        authorized: ['Admin'],
        children: [
            {
                id: 'companies',
                title: 'Compagnies',
                type: 'basic',
                icon: 'heroicons_outline:building-office-2',
                link: '/user-management/companies'
            },
            {
                id: 'users',
                title: 'Utilisateurs',
                type: 'basic',
                icon: 'heroicons_outline:user',
                link: '/user-management/users',
                authorized: ['users']
            },
            {
                id: 'subscriptions',
                title: 'Abonnements',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/subscriptions',
                authorized: ['subscriptions']
            },
            {
                id: 'separtor',
                type: 'divider'
            },
            {
                id: 'localities',
                title: 'Pays et localités',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                link: '/parameters/localities'
            },
            {
                id: 'domains',
                title: 'Domaines d\'activités',
                type: 'basic',
                icon: 'heroicons_outline:rectangle-group',
                link: '/parameters/company-domains'
            },
            {
                id: 'separtor',
                type: 'divider'
            },
            {
                id: 'tasks-manager',
                title: 'Gestion des tâches',
                type: 'basic',
                icon: 'heroicons_outline:cog-6-tooth',
                link: '/parameters/tasks-manager'
            },
            {
                id: 'cube-manager',
                title: 'Gestion des cubes',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/parameters/cube-manager'
            },
            {
                id: 'druid-manager',
                title: 'Gestion Druid',
                type: 'basic',
                icon: 'heroicons_outline:server-stack',
                link: '/parameters/druid-manager'
            }
        ]
    }
];